import React from 'react';
import './Home.css';
import { Redirect } from 'react-router';

const Home = () => {
    return (
        <div>
            <Redirect to="/getting-started" />
        </div>
    );
};

export default Home;
